import { CaretCircleRight } from '@phosphor-icons/react';

export default CaretCircleRight;
